import { render, staticRenderFns } from "./RequestedProcessMaster.vue?vue&type=template&id=db8f8046&scoped=true&"
import script from "./RequestedProcessMaster.vue?vue&type=script&lang=js&"
export * from "./RequestedProcessMaster.vue?vue&type=script&lang=js&"
import style0 from "./RequestedProcessMaster.vue?vue&type=style&index=0&id=db8f8046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8f8046",
  null
  
)

export default component.exports